import { Add } from "@mui/icons-material";
import { Box, Grid2, Paper, Stack, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import FormikTextField from "../../components/form/FormikTextField";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { showLoader, hideLoader } from "../../store/loaderSlice";
import axiosInstance from "../../utils/axiosInstance";
import { usersUrl } from "../../utils/urls";
import PageHeader from "../../components/page-layout/PageHeader";

const AddVendor = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phoneNumber: Yup.string()
      .matches(/^\d{10}$/, "Please enter a valid 10 digit mobile number")
      .required("Mobile number is required"),
  });

  const initialValues = {
    name: "",
    email: "",
    phoneNumber: "",
  };

  const onSubmit = (values, { setSubmitting }) => {
    setIsSubmitting(true);
    dispatch(showLoader("Adding New Vendors..."));

    const submitData = {
      role: "VENDOR",
      name: values.name,
      email: values.email,
      phoneNumber: `+91${values.phoneNumber}`,
      googleId: null,
      imgUrl: null,
      cognitoId: null,
      isVerified: true,
    };

    axiosInstance
      .post(usersUrl, submitData)
      .then((res) => {
        toast.success(res.data.message || "Vendor created successfully");
        navigate(-1);
      })
      .catch((err) => {
        const errorMsg = err.response?.data?.message || err.response?.data?.error || err.message;
        const messages = [];

        if (errorMsg.includes("email")) messages.push("Email already exists");
        if (errorMsg.includes("phone number")) messages.push("Phone number already exists");

        if (messages.length > 0) {
          toast.error(messages.join(" & "));
        } else {
          toast.error(errorMsg);
        }
      })
      .finally(() => {
        dispatch(hideLoader());
        setSubmitting(false);
        setIsSubmitting(false);
      });
  };

  return (
    <Stack spacing={5} height="100%">
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ handleSubmit, values }) => (
          <>
            <PageHeader
              title={"Add Vendor"}
              buttonTitle={"Save Changes"}
              buttonOnClick={handleSubmit}
              showBack={true}
            />

            <Stack direction={{ xs: "column", md: "row" }} spacing={3} px={2} py={3} flex={1}>
              {/* Card UI */}
              <Paper elevation={3} sx={{ p: 3, minWidth: 320, maxWidth: 400, display: "flex", height: "min-content" }}>
                {/* Avatar */}
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    bgcolor: "primary.main",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 32,
                    mr: 3,
                  }}
                >
                  {values.name ? values.name.charAt(0).toUpperCase() : <Add fontSize="large" />}
                </Box>
                {/* Vendor Details */}
                <Stack spacing={1}>
                  <Typography variant="h6">{values.name || "Name"}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {values.email || "Email"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {values.phoneNumber ? `+91${values.phoneNumber}` : "Mobile Number"}
                  </Typography>
                </Stack>
              </Paper>

              {/* Form Fields */}
              <Paper elevation={1} sx={{ flex: 1, p: 3 }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <FormikTextField name="name" label="Name" />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <FormikTextField name="phoneNumber" label="Mobile Number" startAdornment="+91" />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <FormikTextField name="email" label="Email" />
                  </Grid2>
                </Grid2>
              </Paper>
            </Stack>
          </>
        )}
      </Formik>
    </Stack>
  );
};

export default AddVendor;
